import { createBrowserRouter } from 'react-router-dom';
import commonRoutes from './common-routes';
const router = createBrowserRouter(commonRoutes);
export default router;
